import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { saveCommonClsSvc2 } from "./CommonClsSvc";

const lstTmpTchId = []
const EligibleTchPopup2 = (props) => {
    const { commonClsId, subId, eligibleTchId, lstSectionId, closePopup, setLoader, lstTch, getCommonClsList, closeSlider, daysOff, periodsOff } = props;
    const [lstTchId, setLstTchId] = useState([])
    const [filterteacher, setFilterteacher] = useState('')
    const [lstFilteredTch, setLstFilteredTch] = useState([])
    
    useEffect(() => {
        setLstFilteredTch(lstTch)
        setLstTchId(eligibleTchId)
    }, [eligibleTchId])

    function saveCommonCls() {
        if (subId == '' || subId == 0) {
            toast.warn("Please select the subject")
            return;
        }
       /*  if (lstSectionId.length <= 1) {
            toast.warn("Please select atleast 2 classes");
            return;
        } */

        if (lstTchId && lstTchId.length == 0) {
            toast.warn("Please select alteast one teacher");
            return;
        }
        setLoader("block");
        const objCommonCls = {
            subId: subId,
            lstSection: lstSectionId,
            lstTchId: lstTchId,
            daysOff: daysOff,
            periodsOff: periodsOff
        }
        var formData = new FormData();
        formData.append("objCommonCls", JSON.stringify(objCommonCls))
        setLoader("block")
        saveCommonClsSvc2(formData, cbSaveCommonClsResponse)
    }

    function cbSaveCommonClsResponse(data) {
        setLoader("none");
        if (data.status === 'Success') {
            toast.success(data.SvcMsg)
            closePopup();
            closeSlider();
            getCommonClsList();
        }
        else {
            if (data.message === "You are not logged in") {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else if (data.message === "Your Session is expired, login again") {
                toast.error(data.message);
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
    }
    const filterTchTable = (pTch) => {
        // console.log("filterFeeStudnetTable called");
        // console.log("lstFeeStudents", lstFeesStudents);
        // console.log("lstFeeStudent", lstFeesStudent);
        let filterTchList = [];
        filterTchList = lstTch.filter(obj =>
            obj.tch.toString().toLowerCase().includes(pTch.toLowerCase()));
        setLstFilteredTch(filterTchList);
    }

    const handleFilterTeacher = (e) => {
        setFilterteacher(e.target.value);
        filterTchTable(e.target.value);
    }

    const selectAll = (e) => {
        var list_cbox = document.querySelectorAll('#tchBodyTable td input[type=checkbox]');
        list_cbox.forEach((cbox) => { if (cbox.checked !== e.target.checked) cbox.click(); })
    }

    function handleCboxChange(e, obj, status) {
        // console.log(obj, status)
        e.stopPropagation()
        if (status) {
            lstTmpTchId.push(obj.tchId)
        }
        else {
            var idx = existsIn(obj.tchId, lstTmpTchId);
            lstTmpTchId.splice(idx, 1)
        }
        // console.log(lstTmpStudentId)
        setLstTchId(lstTmpTchId)
    }

    function existsIn(pTchId, arr) {
        var idx = -1;
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] === pTchId) {
                idx = i;
                break;
            }
        }
        return idx;
    }

    const colgrpTch = <colgroup>
        <col width="10" />
        <col width="10" />
    </colgroup>

    return (
        <div style={{ display: "flex", justifyContent: "center", position: "absolute", padding: 0, top: "15%", left: "10%", backgroundColor: "#F8F8F8", width: 500, height: 225, zIndex: 1001 }}>
            <div className="form-horizontal formWrapper" style={{ width: "100%", height: "100%", margin: 0 }}>
                <div className="form-group" style={{ marginTop: '15%', height: '70%' }}>
                    {/* <label className="control-label col-sm-5">Teacher</label> */}
                    <div className="col-sm-offset-1 col-sm-8 padding-remove">
                        {/* <select
                            className="form-control"
                            value={''+tchId}
                            onChange={(e) => setTchId(e.target.value)}
                        >
                            <option value={0}>Teacher</option>
                            {lstTch && lstTch.length ?
                                  lstTch.map((tch) => (
                                    <option key={tch.tchId} value={tch.tchId} >{tch.tch}</option>
                                )) : null
                            }
                        </select> */}
                        <div className="col-md-12">
                            <table className="tableLayout1">
                                {colgrpTch}
                                <thead>
                                    <tr>
                                        <th>
                                            <input type="text" className="form-control inp-search text-left"
                                                value={filterteacher}
                                                onChange={(e) => { handleFilterTeacher(e) }}
                                                placeholder="Teacher"
                                            />
                                        </th>

                                        <th>Select
                                            <div>
                                                <input onChange={(e) => selectAll(e)} type="checkbox" id="cbxSelectAll" />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                            <div
                                className="tchTableDiv"
                                style={{
                                    height: "400px",
                                    overflowY: "scroll",
                                    border: "1px solid #ccc",
                                }}
                            >
                                <table id="tchTable" className="tableLayout">
                                    {colgrpTch}
                                    <tbody id="tchBodyTable">
                                        {lstFilteredTch && lstFilteredTch.map((tch, i) => (
                                            <tr key={tch.tchId} id={tch.tchId}>
                                                <td className="text-left">{tch.tch}</td>
                                                <td className='text-center' onClick={(e) => { e.stopPropagation(); e.target.firstChild.click() }}>
                                                    <input key={'tchs_' + tch.tchId}
                                                        id={'tchs_' + tch.tchId}
                                                        onClick={(e) => handleCboxChange(e, tch, e.target.checked)}
                                                        type="checkbox"
                                                        defaultChecked={false}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group" style={{ marginTop: 10 }}>
                    <div className="col-sm-12 text-center userButtonWrap" >
                        <button type="button" title="Save" onClick={() => saveCommonCls()} className="btn btn-info">Save</button>
                        <button type="button" title="Cancel" onClick={() => closePopup()} className="btn btn-info">Close</button>
                        {/* {commonClsId == 0 &&
                            <button type="button" title="Delete" onClick={() => deletePeriod(schedulePeriodId)} className="btn btn-danger deleteButton">Delete</button>
                        } */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EligibleTchPopup2;